<template>
  <div/>
</template>

<script>
import {sliderStart} from "@/utils/slider";
import {checkCaptcha, getCaptcha} from "@/api/auth";

export default {
  name: "CaptchaSlider",
  created() {
    this.init()
  },
  methods: {
    async init() {
      const _this = this
      const option = await _this.getCaptchaInfo()
      sliderStart(
          option,
          /**
           *
           * @param sliderKey 验证key
           * @param sliderX 验证x轴距离
           * @param sliderSuccess 验证成功回调
           * @param sliderError 验证失败回调
           * @returns {Promise<void>}
           */
          async function (sliderKey, sliderX, sliderSuccess, sliderError) {
            const {success, model} = await checkCaptcha({sliderKey, sliderX})
            if (!success || !model) {
              await _this.getCaptchaInfo(sliderError)
              return;
            }
            sliderSuccess()
            setTimeout(() => {
              _this.$emit('success')
            }, 100)
          },
          async function (refresh) {
            // 刷新
            await _this.getCaptchaInfo(refresh)
          })
    },
    async getCaptchaInfo(callback) {
      const {success, model} = await getCaptcha()
      if (!success) {
        return;
      }
      const options = {
        title: '',
        sliderBg: model.img,
        sliderKey: model.key,
        sliderY: model.y
      }
      if (!callback)
        return options
      callback(options)
    },
  }
}
</script>

<style scoped>

</style>